import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { VisitsCallsTargetsService, VisitsCallsTargetsServiceData } from "../../services/visitsCallsTargetsKpi/visitsCallsTargets.service";
import { ColumnDefinition, DateColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class VisitsTargetDOData {
    public visits: number;
    public target: number;
    public globalVisits: number;
    public globalTarget: number;

    constructor(visits: number, target: number, globalVisits: number, globalTarget: number) {
        this.visits = visits;
        this.target = target;
        this.globalVisits = globalVisits;
        this.globalTarget = globalTarget;
    }
}

export class VisitsTargetDODetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'visits-target-do-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class VisitsTargetDOKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<VisitsCallsTargetsService, VisitsCallsTargetsServiceData, VisitsTargetDOData, VisitsTargetDODetailData>
    implements OnDestroy {
    public getClassName() { return "VisitsTargetDOKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: VisitsCallsTargetsService) {
        super(zone, logger, summaryService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: VisitsCallsTargetsServiceData, updateRequested: Boolean): VisitsTargetDOData {
        let visits = 0;
        let target = 0;

        let thisWeek = moment().isoWeek();
        let updateTime = this.extractUpdateTime(data);
        let now = moment();
        if (updateTime && moment(updateTime).isoWeek() == thisWeek) {
            let diff = moment.duration(now.diff(moment(data.officeVisitsUpdateTimestamp)));
            if (diff.hours() < 2 && this.summaryData && updateRequested) {
                this.messageDialog.open();
            }

            if (data.consultantEntry) {
                visits = (data.consultantEntry.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek).length;
                target = data.consultantEntry.visitsTarget;
            }
        }

        let officeVisitCount = (data.entries || []).map(x => (x.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek).length).reduce((accum, x) => accum + x, 0);
        return new VisitsTargetDOData(visits, target, officeVisitCount, data.officeVisitsTarget);
    }

    protected getDefaultSummaryData(): VisitsTargetDOData {
        let data = new VisitsTargetDOData(0, 0, 0, 0);
        return data;
    }

    protected extractUpdateTime(data: VisitsCallsTargetsServiceData): Date {
        if (data) {
            return moment(data.officeVisitsUpdateTimestamp).isBefore(moment(data.officeVisitsTargetUpdateTimestamp)) ?
                data.officeVisitsTargetUpdateTimestamp : data.officeVisitsUpdateTimestamp;
        } else {
            return new Date();
        }
    }

    protected processDetailData(data: VisitsCallsTargetsServiceData, args: any): VisitsTargetDODetailData {
        if (args && args.filter && args.filter.wholeOffice) {
            if (data.entries) {
                let thisWeek = moment().isoWeek();
                let columnDefinitions = [
                    new TextColumnDefinition("Cliente"),
                    new TextColumnDefinition("Segmento"),
                    new TextColumnDefinition("Tipo"),
                    new DateColumnDefinition("Fecha", (data) => moment(data).format("DD/MM/YYYY")),
                    new TextColumnDefinition("Consultor", null, true)
                ];

                let tabledata = [];
                for (let entry of data.entries) {
                    for (let visit of (entry.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek)) {
                        tabledata.push([
                            visit.clientName,
                            "S" + visit.segment,
                            visit.type,
                            moment(visit.date).startOf("day"),
                            entry.name
                        ]);
                    }
                }

                return new VisitsTargetDODetailData(columnDefinitions, tabledata);
            } else return this.getDefaultDetailData();
        } else {
            if (data.consultantEntry) {

                let thisWeek = moment().isoWeek();

                let columnDefinitions = [
                    new TextColumnDefinition("Cliente"),
                    new TextColumnDefinition("Segmento"),
                    new TextColumnDefinition("Tipo"),
                    new DateColumnDefinition("Fecha", (data) => moment(data).format("DD/MM/YYYY"))
                ];

                let tabledata = [];
                for (let visit of (data.consultantEntry.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek)) {
                    tabledata.push([

                        visit.clientName,
                        "S" + visit.segment,
                        visit.type,
                        moment(visit.date).startOf("day")
                    ]);
                }

                return new VisitsTargetDODetailData(columnDefinitions, tabledata);
            } else return this.getDefaultDetailData();
        }
    }

    protected getDefaultDetailData() {
        let columnDefinitions = [
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Segmento"),
            new TextColumnDefinition("Tipo"),
            new DateColumnDefinition("Fecha", (data) => moment(data).format("DD/MM/YYYY"))
        ];

        return new VisitsTargetDODetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
